import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import actions from "actions";
import { UserSponsorList } from "components/Admin/UserSponsor/List/UserSponsorList";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import Toolbar from "components/Admin/UserSponsor/Toolbar";
import Calendar, { momentLocalizer } from "react-big-calendar";
import moment from "moment";

import "react-big-calendar/lib/css/react-big-calendar.css";

const { showDeleteUsersConfirmationModal, adminUserSponsorFilter } = actions;

class UsersSponsors extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.timer = true;
    this.state = {
      user_ids: [],
      page: props.page || 1,
      searchQuery: {
        order: {
          created_at: "desc",
        },
        ...props.query,
      },
      startDate: null,
      endDate: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.total_pages != this.props.total_pages)
      this.setState({
        page: 1,
      });
  }

  componentWillMount = () => {
    this.updateUsersList();
  };

  deleteUsers = () => {
    if (this.state.user_ids.length > 0)
      this.props.deleteUsers(this.state.user_ids);
  };

  onChangePage = (page = 1) => {
    this.setState(
      {
        page,
      },
      this.updateUsersList
    );
  };

  onOrderChange = (field = "created_at", order = "desc") => {
    const searchQuery = {
      ...this.state.searchQuery,
      order: {
        [field]: order,
      },
    };
    this.setState(
      {
        searchQuery,
      },
      this.updateUsersList
    );
  };

  // showHideRepresentative = () => {
  //   const { query } = this.props;
  //   const searchQuery = {
  //     ...this.state.searchQuery,
  //     is_representative: !query.is_representative,
  //   };
  //   this.setState(
  //     {
  //       searchQuery,
  //     },
  //     this.updateUsersList
  //   );
  // };

  checkedUserIds = (user_id) => {
    var ids = _.assign(this.state.user_ids),
      index = this.state.user_ids.indexOf(user_id);

    if (index == -1) {
      ids.push(user_id);
    } else {
      ids.splice(index, 1);
    }
    this.setState({ user_ids: ids });
  };

  changeFilterQuery = (field, value) => {
    const query = { ...this.state.searchQuery, ...{ [field]: value } };
    this.setState({ searchQuery: query, page: 1 }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.updateUsersList, 500);
    });
  };

  onDateRangeChange = (field, start, end) => {
    const query = {
      ...this.state.searchQuery,
      ...{ [`${field}_from`]: start, [`${field}_to`]: end },
    };
    this.setState({ searchQuery: query, page: 1 }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.updateUsersList, 500);
    });
  };

  updateUsersList = () => {
    const { page, searchQuery } = this.state;
    this.props.userFilter(searchQuery, page);
  };

  render() {
    const { setState, deleteUsers } = this;
    const localizer = momentLocalizer(moment);

    return (
      <main className="site--width clearfix container_statistics">
        <Toolbar
          toolsProps={{
            deleteUsers,
            count: this.props.count,
            // showHideRepresentative: this.showHideRepresentative,
            // isRepresentative: this.props.query ? this.props.query.is_representative : false,
          }}
        />
        <div className="admin_user_table admin_table">
          <UserSponsorList
            onOrderChange={this.onOrderChange}
            query={this.state.searchQuery}
            users={this.props.users}
            checkedUserIds={this.checkedUserIds}
            user_ids={this.state.user_ids}
            paginationProps={{
              onChangePage: this.onChangePage,
              page: this.state.page,
              total_pages: this.props.total_pages,
            }}
          />
        </div>
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    users: state.users.adminUsers.values,
    count: state.users.adminUsers.count,
    total_pages: state.users.adminUsers.total_pages,
    page: state.users.adminUsers.page,
    query: state.users.adminUsers.query,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch,
    deleteUsers: (user_ids) =>
      dispatch(showDeleteUsersConfirmationModal(user_ids)),
    userFilter: (query, page) => dispatch(adminUserSponsorFilter(query, page)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersSponsors);



// WEBPACK FOOTER //
// ./src/containers/Admin/UserSponsors/UsersSponsors.jsx